import * as defaultImport from "@splunk/visualizations/MarkerGauge";
export * from "@splunk/visualizations/MarkerGauge";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
